import { Controller, FieldValues, Path, useFormState } from 'react-hook-form';
import { FormHelperText, TextField, TextFieldProps } from '@mui/material';
import { ErrorMessage } from '@hookform/error-message';

interface Props<TFieldValues extends FieldValues = FieldValues>
  extends Omit<TextFieldProps, 'name'> {
  name: Path<TFieldValues>;
}

export function TextInput<TFieldValues extends FieldValues = FieldValues>(
  props: Props<TFieldValues>
) {
  const { errors } = useFormState();
  return (
    <Controller
      name={props.name}
      defaultValue={'' as any}
      render={({ field: { ref, ...fieldProps } }) => (
        <>
          <TextField inputRef={ref} {...props} {...fieldProps} error={!!errors[props.name]} />
          <ErrorMessage
            errors={errors}
            name={props.name}
            render={data => <FormHelperText error>{data.message}</FormHelperText>}
          />
        </>
      )}
    />
  );
}
